import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {ListResponse} from "../interface/response/list-response";
import {first} from "rxjs/operators";
import {HiperioConfig} from "../interface/hiperio-config";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {Dictionary} from "../interface/dictionary";


@Injectable({
  providedIn: 'root'
})
export class HiperioConfigService {
  loaded = false;
  private readonly hiperioConfigSubject: ReplaySubject<Array<HiperioConfig>> = new ReplaySubject();

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.loadList();
  }

  public loadList(): void {
    this.httpClient.get(`/rest/crm/hiperio-config`)
      .pipe(
        first()
      )
      .subscribe((response: ListResponse<HiperioConfig>) => {
        this.hiperioConfigSubject.next(response.items);
        this.loaded = true;
      });
  }

  public get(id: number): Observable<HiperioConfig> {
    this.loadIfNotLoaded();
    const hiperioConfigObservable: ReplaySubject<HiperioConfig> = new ReplaySubject<HiperioConfig>(1);

    this.hiperioConfigSubject.pipe(first())
      .subscribe((items: HiperioConfig[]) => {
        items.some((el: HiperioConfig) => {
          if (el.id === id) {
            hiperioConfigObservable.next(el);
            hiperioConfigObservable.complete();
            return true;
          }

          return false;
        });

        hiperioConfigObservable.complete();
      });

    return hiperioConfigObservable.pipe(first());
  }

  private loadIfNotLoaded(): void {
    if (!this.loaded) {
      this.loadList();
    }
  }

  public getHiperioConfigSubject(): ReplaySubject<Array<HiperioConfig>> {
    return this.hiperioConfigSubject;
  }

}
